import { render, staticRenderFns } from "./ProductCountdown.vue?vue&type=template&id=91124622"
import script from "./ProductCountdown.vue?vue&type=script&lang=js"
export * from "./ProductCountdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports